// Exports
export default {
	"link": "link_+pPMo"
};
